import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export const ProgressInfoTooltip = ({ label, content, testId }) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <button
        type="button"
        className="inline-flex items-center justify-center rounded-sm text-dark-text-muted hover:text-dark-text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2 focus-visible:ring-offset-dark-surface-1"
        aria-label={`More information about ${label}`}
        data-testid={testId}
      >
        <Info className="w-3.5 h-3.5" strokeWidth={1.5} aria-hidden="true" />
      </button>
    </TooltipTrigger>
    <TooltipContent className="max-w-xs bg-dark-surface-3 text-dark-text-primary border border-dark-border text-xs leading-relaxed">
      {content}
    </TooltipContent>
  </Tooltip>
);
